

















































































import _ from "lodash";
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Mixins,
} from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import InvoiceSeq from "@/store/entities/create-invoice-seq";
@Component
export default class CreateInvoiceSeq extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  invoiceSeq: InvoiceSeq = new InvoiceSeq();
  clients = [];
  get fromNumberString() {
    var fromNumberStr = "";
    if (!Util.isNull(this.invoiceSeq.fromNumber))
      fromNumberStr = String(this.invoiceSeq.fromNumber);
    return _.padStart(fromNumberStr, this.invoiceSeq.length, "0");
  }
  get endNumberString() {
    var endNumberStr = "";
    if (!Util.isNull(this.invoiceSeq.endNumber))
      endNumberStr = String(this.invoiceSeq.endNumber);
    return _.padStart(endNumberStr, this.invoiceSeq.length, "0");
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateInvoiceSeq"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        await this.$store
          .dispatch({
            type: "invoiceSeq/create",
            data: this.invoiceSeq,
          })
          .then(() => {
            Util.showSuccessMsg(this, "Success.CreateInvoiceSeq");
            this.invoiceSeq = new InvoiceSeq();
            (this.$refs.invoiceSeqForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          });
      },
    });

    //  (this.$refs.invoiceSeqForm as any).validate(async (valid: boolean) => {
    //    if (valid) {

    //     }
    //     else
    //     {
    //     }
    //   });
  }
  cancel() {
    this.invoiceSeq = new InvoiceSeq();
    (this.$refs.invoiceSeqForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.clients = this.$store.state.client.clientsForSelect;
      this.invoiceSeq.clientCode =
        this.clients.length === 0 ? "" : this.clients[0].code;
    }
  }
  mounted() {
    if (Util.isNull(this.clients) || this.clients.length <= 0) {
      this.clients = this.$store.state.client.clientsForSelect;
      this.invoiceSeq.clientCode =
        this.clients.length === 0 ? "" : this.clients[0].code;
    }
  }
  validateCode = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error(this.L("Error.ClientRequired")));
    } else {
      callback();
    }
  };
  validateNumber = (rule: any, value: any, callback: any) => {
    if (!value || +value <= 0) {
      callback(new Error(this.L("Error.Required")));
    } else {
      callback();
    }
  };
  invoiceSeqRule = {
    clientCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Client")),
        trigger: "blur",
      },
      { validator: this.validateCode, trigger: "blur" },
    ],
    length: [
      {
        required: true,
        type: "number",
        message: this.L("Error.RequiredField", undefined, this.L("Length")),
        trigger: "blur",
      },
      { validator: this.validateNumber, trigger: "blur" },
    ],
    fromNumber: [
      {
        required: true,
        type: "number",
        message: this.L("Error.RequiredField", undefined, this.L("FromNumber")),
        trigger: "blur",
      },
      { validator: this.validateNumber, trigger: "blur" },
    ],
    endNumber: [
      {
        required: true,
        type: "number",
        message: this.L("Error.RequiredField", undefined, this.L("EndNumber")),
        trigger: "blur",
      },
      { validator: this.validateNumber, trigger: "blur" },
    ],
  };
}
